import { CommonModule } from '@angular/common';
import { LocalizationService, SubscriptionService, LocalizationModule } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import { ColDef } from '@ag-grid-community/core';
import { Component, Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  DwGridDataSourceService,
  FieldTypes,
  IEnumerationCellRendererParams,
} from '@digiwall/ag-grid';
import {
  SupplierPreparationListDto,
  SupplierPreparationService,
  SupplierPreparationStatus,
} from '@digiwall/goliath-documents/proxy';
import { BaseSupplierDocList } from '../../base-supplier-docs/base-supplier-doc-list';
import { ListPageComponent } from '@digiwall/ag-grid';
import { AgGridComponent } from '@digiwall/ag-grid';

@Component({
  selector: 'document-supplier-preparation-list',
  templateUrl: './supplier-preparation-list.component.html',
  styles: `
    :host {
      flex-grow: 1;
    }
  `,
  providers: [DwGridDataSourceService, SubscriptionService],
  imports: [CommonModule, ListPageComponent, AgGridComponent, LocalizationModule],
})
export class SupplierPreparationListComponent extends BaseSupplierDocList<
  SupplierPreparationListDto,
  SupplierPreparationService
> {

  private readonly defaultColumns = [ 'dayBook', 'displayNumber', 'documentDate', 'thirdPartyCode', 'thirdPartyName', 'reference', 'supplierPreparationStatusId', 'isClosed' ];

  protected override get enableDelete(): boolean {
    const entities = this.selectedEntities();
    if (!entities?.length) return false;
    const draftStatus = this.documentEnumerationTypeStore.supplierPreparationStatus()
      .find(s => s.id === SupplierPreparationStatus.Draft);
    return draftStatus != null &&
      entities.every(e =>
        e.supplierPreparationStatusId === draftStatus.id ||
        e.supplierPreparationStatusId === draftStatus.name?.current
      );
  }

  override colDefs: ColDef[] = [
    ...this.colDefs,
    {
      field: 'supplierDeliveryModeId',
      headerName: this.localizationService.instant('GoliathCore::DeliveryMode'),
      type: FieldTypes.Enumeration,
      cellRendererParams: {
        entities: this.coreEnumerationTypeStore.supplierDeliveryModes,
      } as IEnumerationCellRendererParams,
    },
    {
      field: 'supplierPreparationStatusId',
      headerName: this.localizationService.instant('Doc::SupplierPreparation:PreparationStatus'),
      type: FieldTypes.Enumeration,
      cellRendererParams: {
        entities: this.documentEnumerationTypeStore.supplierPreparationStatus,
      } as IEnumerationCellRendererParams,
    },
  ].map(col => {
    col.hide = !this.defaultColumns.some(x => col.field == x)
    return col;
  });

  constructor(
    protected supplierPreparationService: SupplierPreparationService,
    router: Router,
    route: ActivatedRoute,
    localizationService: LocalizationService,
    subscriptionService: SubscriptionService,
    confirmation: ConfirmationService,
    datasource: DwGridDataSourceService,
    injector: Injector,
  ) {
    super(
      supplierPreparationService,
      router,
      route,
      confirmation,
      localizationService,
      subscriptionService,
      datasource,
      injector,
    );
    this.colDefs.sort(
      (a, b) =>
        (this.defaultColumns.indexOf(String(a.field)) === -1
          ? Number.MAX_SAFE_INTEGER
          : this.defaultColumns.indexOf(String(a.field))) -
        (this.defaultColumns.indexOf(String(b.field)) === -1
          ? Number.MAX_SAFE_INTEGER
          : this.defaultColumns.indexOf(String(b.field)))
    );
  }
}
